import type transform from '../to/courses';

export default (courses: ReturnType<typeof transform>) => {
  if (courses.length != new Set(courses.map(x => x.id)).size)
    throw new Error('(Core::From::V2::Courses) Course array have two or more courses with the same ID');

  return courses
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::Courses) Course id is undefined');

      return { ...x };
    });
};
